export default __webpack_public_path__ + "static/media/ISO-compliant.933da426.svg";